module.exports = __webpack_public_path__ + "static/img/kv@2x_2023.87bd9389.png";